import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import css from "./TerAct.module.css";
import { ClinicContext } from "../../Context/ClinicContext";
import { Head } from "../../Utils/Head";
import { UserContext } from "../../Context/UserContext";
import { updateUserFirebase } from "../../Utils/firebaseUser";
import { valuesQuestionarePt } from "../../Utils/valuesQuestionare";

export const ValuesAndTrends = () => {
  const { userData, setUserData } = useContext(UserContext);
  const { step, setStep } = useContext(ClinicContext);
  const [VLQvalues, setVLQvalues] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const VLQarr = new Array(6);
  for (let i = 0; i < VLQarr.length; i++) {
    VLQarr[i] = new Array(6).fill(false);
  }
  const navigate = useNavigate();
  const stepLength = 7;

  const handleCheck = (row, col) => {
    const arr = [...VLQvalues];
    if (arr.indexOf(col) >= 0) {
      arr[arr.indexOf(col)] = false;
      arr[row] = col;
      setVLQvalues(arr);
    } else {
      arr[row] = col;
      setVLQvalues(arr);
    }
  };

  const validateVLQvalues = () => {
    let counter = 0;
    VLQvalues.indexOf(0) >= 0 && counter++;
    VLQvalues.indexOf(1) >= 0 && counter++;
    VLQvalues.indexOf(2) >= 0 && counter++;
    VLQvalues.indexOf(3) >= 0 && counter++;
    VLQvalues.indexOf(4) >= 0 && counter++;
    VLQvalues.indexOf(5) >= 0 && counter++;

    return counter === 6 ? true : false;
  };

  const finish = () => {
    const updatedJourney = {
      level: 0,
      lesson: 5,
    };

    userData.journey = updatedJourney;
    userData.listValues = VLQvalues;
    setUserData(userData);
    updateUserFirebase(userData);
    setStep(0);
    navigate("/");
  };

  return (
    <div className={css.container}>
      <Head
        title="JourneyIntroduction"
        description={"SufferingAxis - Mairini"}
      />
      <section className={css.gridTop}>
        <i
          className={`material-icons ${css.topbarIcon}`}
          onClick={() => {
            setStep(0);
            navigate("/");
          }}
        >
          close
        </i>
        <div className={css.traitBar}>
          <div
            className={css.traitScore}
            style={{
              marginRight: `${((stepLength - step) * 100) / stepLength}%`,
            }}
          ></div>
        </div>
      </section>
      <section className={css.gridMain}>
        {step === 0 && (
          <div className={css.gridMainContainer}>
            <p>
              Agora que você refletiu sobre sua personalidade, é hora de
              explorar um dos pontos mais importantes da jornada:
              <span> os seus valores.</span>
            </p>
          </div>
        )}
        {step === 1 && (
          <div className={css.gridMainContainer}>
            <h1>Mas antes… o que são valores?</h1>
            <p>
              Valores são qualidades de vida que você quer sustentar. Eles não
              são objetivos que se alcança, mas
              <span> direções que guiam suas escolhas.</span>
            </p>
          </div>
        )}
        {step === 2 && (
          <div className={css.gridMainContainer}>
            <h1>Exemplo:</h1>
            <h1>
              Você pode valorizar saúde, família ou carreira. Esses valores
              podem se expressar de formas diferentes conforme sua
              personalidade.
            </h1>
          </div>
        )}
        {step === 3 && (
          <div className={css.gridMainContainer}>
            <p>
              Vamos fazer um exercício para entender as áreas da vida que são
              mais importantes para você.
            </p>
            <h1>
              Responda ao questionário independentemente de sua situação atual.
            </h1>
            <p>
              Lembre-se que valores são direções que guiam nossas escolhas no
              caminho da vida.
            </p>
            <p>
              Você terá 18 pontos para distribuir entre as 6 categorias,
              conforme a importância.
            </p>
            <p>
              Nem todas as pessoas irão valorizá-las ou avaliá-las da mesma
              forma. Utilize as sentenças como exemplos de cada categoria.
            </p>
          </div>
        )}
        {step === 4 && (
          <>
            <form>
              <p>Escolha de acordo com a importância:</p>
              <p>Você poderá atribuir apenas um número para cada valor</p>
              <p>(0) Não importante (1) Pouco importante (2) Importante</p>
              <p>
                (3) Muito importante (4) Extremamente importante (5) Necessário
              </p>
              {valuesQuestionarePt.map((question, row) => (
                <React.Fragment key={row}>
                  <div></div>
                  <div className={css.valuesContainer}>
                    <h4>{question.value} </h4>
                    <div>
                      <label className={css.confirmation}>
                        (0)
                        <input
                          type="checkbox"
                          checked={VLQvalues[row] === 0}
                          onChange={() => {
                            handleCheck(row, 0);
                          }}
                        />
                        <span className={css.checkmark}></span>
                      </label>
                      <label className={css.confirmation}>
                        (1)
                        <input
                          type="checkbox"
                          checked={VLQvalues[row] === 1}
                          onChange={() => {
                            handleCheck(row, 1);
                          }}
                        />
                        <span className={css.checkmark}></span>
                      </label>
                      <label className={css.confirmation}>
                        (2)
                        <input
                          type="checkbox"
                          checked={VLQvalues[row] === 2}
                          onChange={() => {
                            handleCheck(row, 2);
                          }}
                        />
                        <span className={css.checkmark}></span>
                      </label>
                      <label className={css.confirmation}>
                        (3)
                        <input
                          type="checkbox"
                          checked={VLQvalues[row] === 3}
                          onChange={() => {
                            handleCheck(row, 3);
                          }}
                        />
                        <span className={css.checkmark}></span>
                      </label>
                      <label className={css.confirmation}>
                        (4)
                        <input
                          type="checkbox"
                          checked={VLQvalues[row] === 4}
                          onChange={() => {
                            handleCheck(row, 4);
                          }}
                        />
                        <span className={css.checkmark}></span>
                      </label>
                      <label className={css.confirmation}>
                        (5)
                        <input
                          type="checkbox"
                          checked={VLQvalues[row] === 5}
                          onChange={() => {
                            handleCheck(row, 5);
                          }}
                        />
                        <span className={css.checkmark}></span>
                      </label>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </form>
          </>
        )}
        {step === 5 && (
          <>
            <p>
              Você escolheu os valores na seguinte ordem. Verifique se as frases
              estão de acordo com a direção que deseja seguir ou retorne para
              refazer a lista de valores.
            </p>
            <p>
              <strong>
                1. {valuesQuestionarePt[VLQvalues.indexOf(5)].value}
              </strong>
            </p>
            <p>
              {valuesQuestionarePt[VLQvalues.indexOf(5)].sentences.map(
                (s) => s + " "
              )}
            </p>
            <p>
              <strong>
                2. {valuesQuestionarePt[VLQvalues.indexOf(4)].value}
              </strong>
            </p>
            <p>
              {valuesQuestionarePt[VLQvalues.indexOf(4)].sentences.map(
                (s) => s + " "
              )}
            </p>
            <p>
              <strong>
                3. {valuesQuestionarePt[VLQvalues.indexOf(3)].value}
              </strong>
            </p>
            <p>
              {valuesQuestionarePt[VLQvalues.indexOf(3)].sentences.map(
                (s) => s + " "
              )}
            </p>
          </>
        )}
        {step === 6 && (
          <div className={css.gridMainContainer}>
            <h1> 💡 Dica:</h1>
            <h1>
              "Viver pelos seus valores não significa viver sem desconforto.
              Significa escolher o desconforto que vale a pena."
            </h1>
          </div>
        )}
        {step === 7 && (
          <div className={css.gridMainContainer}>
            <h1>
              👏 Parabéns! Identificar seus valores com base no seu jeito de ser
              é um passo precioso.
            </h1>
            <p>
              Na próxima lição, você poderá montar uma jornada personalizada
              para seguir adiante com intenção.
            </p>
          </div>
        )}
      </section>
      <div>
        <section className={css.gridOptions}>
          {step > 0 ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step - 1);
              }}
            >
              Anterior
            </button>
          ) : (
            <button className={`greenButton ${css.buttonDisabled}`}>
              Anterior
            </button>
          )}
          {step === 4 ? (
            validateVLQvalues() ? (
              <button
                className={`greenButton ${css.button}`}
                onClick={() => setStep(step + 1)}
              >
                Próximo
              </button>
            ) : (
              <button className={`greenButton ${css.buttonDisabled}`}>
                Próximo
              </button>
            )
          ) : step === stepLength ? (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                finish();
              }}
            >
              Finalizar
            </button>
          ) : (
            <button
              className={`greenButton ${css.button}`}
              onClick={() => {
                setStep(step + 1);
              }}
            >
              Próximo
            </button>
          )}
        </section>
      </div>
    </div>
  );
};
